app.controller('navCtrl', [
    '$scope', '$state', 'appService', 'authService', 'gameService', '$window', '$transitions', 'logoutService', function ($scope, $state, appService, authService, gameService, $window, $transitions, logoutService) {
    	$scope.appService = appService;
        $scope.authService = authService;
        $scope.gameService = gameService;
        $scope.logoutService = logoutService;

    	$scope.isiOS = appService.isiOS();
    	$scope.isiPhoneX = appService.isiPhoneX();
    	$scope.isAndroid = appService.isAndroid();

        $scope.isCurrentPage = function (state) {
            return $state.current.name.substring(0, state.length) === state;
        }

        $scope.isActualPage = function (state) {
            return state === $state.current.name;
        }

		$transitions.onSuccess({}, function(transition) {
			var newState = transition.to().name;

			if (newState === "student" || newState.indexOf("student.") === 0) {
				$scope.items =  $scope.studentItemsFiltered();
			} else if (newState === "teacher" || newState.indexOf("teacher.") === 0) {
				$scope.items = $scope.teacherItems;
            } else if (newState === "teacherapp" || newState.indexOf("teacherapp.") === 0) {
                $scope.items = $scope.teacherAppItems;
            } else {
				$scope.items = $scope.tivoliItems;
			}
		});

    	$scope.teacherItems = [
            {
                state: "teacher.signup",
                displayName: "Kom i gang",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacher.setupexercises",
                displayName: "Vælg opgaver",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacher.setupgroups",
                displayName: "Opret grupper",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacher.groups",
                displayName: "Gruppeoversigt",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacher.evaluation",
                displayName: "Evaluering",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacher.info",
                displayName: "Vigtig info",
                iconClass: "",
                bigIcon: false
            }
    	];

        $scope.teacherAppItems = [
            {
                state: "teacherapp.welcome",
                displayName: "Velkommen",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacherapp.groupstatus",
                displayName: "Status på grupper",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacherapp.exercises",
                displayName: "Opgaveoversigt",
                iconClass: "",
                bigIcon: false
            },
            {
                state: "teacherapp.groupmap",
                displayName: "Kort",
                iconClass: "",
                bigIcon: false
            }
        ];

    	$scope.tivoliItems = [
    		{
    			state: "home",
    			displayName: "Hjem",
    			iconUrl: "/img/IconOpgaver.png"
    		},
    		{
    			state: "exercises",
    			displayName: "Opaver",
    			iconUrl: "/img/IconOpgaver.png"
    		},
            {
                state: "config",
                displayName: "Config",
                iconUrl: "/img/IconOpgaver.png"
            },
            {
                state: "testticket",
                displayName: "Test-biletter",
                iconUrl: "/img/IconOpgaver.png"
            },
            {
                state: "rides",
                displayName: "Forlystelser",
                iconUrl: "/img/IconOpgaver.png"
            },
            {
                state: "freegame",
                displayName: "Øvelsesopgave",
                iconUrl: "/IconOpgaver.png"
            },
            {
                state: "stats",
                displayName: "Statistik",
                iconUrl: "/img/IconOpgaver.png"
            },
    		{
    			state: "profile",
    			displayName: "Profil",
    			iconUrl: "/img/IconOpgaver.png"
    		},
    	];

    	$scope.items = [];

        $scope.studentItemsFiltered = function() {
            var items = [];
            if (gameService.isWelcomeNotFinished()) {
                items.push({
                    state: "student.welcome",
                    displayName: "Velkommen",
                    iconClass: "icon-velkommen",
                    bigIcon: true
                });
            } else {
                if (!gameService.isGameDone()) {
                    items.push({
                        state: 'student.exercises',
                        displayName: 'Opgaver',
                        iconClass: 'icon-opgaver',
                        bigIcon: false
                    });
                }
                if (gameService.isGameDone()) {
                    items.push({
                        state: "student.trophy",
                        displayName: "Point",
                        iconClass: "icon-point",
                        bigIcon: false
                    });
                }
            }
            return items;
        }

        $scope.showCookieDialog = function() {
            var cookieStateIsSupported = (window.tuAndroid != null && window.tuAndroid.setCookieState != null) || (window.webkit != null && window.webkit.messageHandlers != null && window.webkit.messageHandlers["setCookieState"] != null);
            if (!cookieStateIsSupported) {
                return;
            }
            var showRemoveButton = $window.localStorage.getItem('cookieState') == 'all';
            if (showRemoveButton) {
                appService.showCookieRemoveDialog();
            } else {
                appService.showCookieDialog();
            }
        }
	}
]);